export default __webpack_public_path__ + "static/media/tool_R4b_form.2bed4175.pdf";